module.exports = __webpack_public_path__ + "static/media/picture 1 - monika.f31bb34f.png";